import http from '@/http-common'
import Title from "@/components/TitlePage.vue";

export default {
    components: {Title},
    data() {
        return {
            items: [],
            selectYear: new Date().getFullYear()+1,
            columns: [
                {
                    key: 'federationName',
                    label: 'Федерация',
                    variant: 'info', stickyColumn: true,
                    thClass: 'bg-dark text-light'
                }
            ],
            columnsChild: [],
            captionTable: 'Отчет по заявкам',
            isBusy: false,
            heads:[],
            showFilter: false,
            filterFields: [
                {value: null, text: '-- укажите поле --', disable: true},
                {value: 'all', text: 'Всего'},
                {value: 'new', text: 'Новые'},
                {value: 'accept', text: 'Согласовано'},
                {value: 'cancel', text: 'Отменено'},
            ],
            filterOperations: [
                {value: null, text: '-- укажите операцию --', disable: true},
                {value: 0, text: 'равно ='},
                {value: 1, text: 'больше или равно >'},
                {value: 2, text: 'меньше или равно <'}
            ],
            filterOption: {
                fieldName: null,
                operation: null,
                fieldValue: null
            },
            filter: {
                fieldName: null,
                operation: null,
                fieldValue: null,
                federation: null
            },
            excel_fields: [],
            fileName: 'Отчет по заявкам',
            filteredItems: []
        }
    },
    methods: {
        loadItems() {
            var vm = this;
            vm.isBusy = true;
            vm.heads = []
            vm.columns = [
                {
                    key: 'federationName',
                    label: 'Федерация',
                    variant: 'info', stickyColumn: true,
                    thClass: 'bg-dark text-light',
                }
            ];
            this.excel_fields =[
                {field:'federationName', label: 'Федерация'}
                ]
            for (let i=vm.selectYear-1; i <= vm.selectYear; i++) {
                var head = {};
                head.name = i.toString();
                head.count = 4;
                head.thClass = i == vm.selectYear ? 'bg-dark text-light' : 'bg-primary text-light'
                vm.heads.push(head);
                this.filterFields.forEach(function (filter) {
                    if (filter.value) {
                        var col = {
                            key: filter.value + '_' + i.toString(),
                            label: filter.text,
                            variant: i === vm.selectYear ? 'info' : 'light',
                            thClass: (i === vm.selectYear ? 'bg-dark text-light' : 'bg-primary text-light') + ' text-center',
                            tdClass: 'text-center',
                            tdAttr: filter.value === 'all' ? 'attrRow' : null
                        }
                        var colExcel = {
                            field: filter.value + '_' + i.toString(),
                            label: filter.text + '_' + i.toString()
                        }
                        vm.columns.push(col);
                        vm.excel_fields.push(colExcel)
                    }
                })
            }
            http.get('/request/report/'+this.selectYear)
                .then((response) => {
                    vm.items = response.data;
                    vm.items.forEach(function (x) {
                      var details = x.countDetailList;
                      details.forEach(function (child) {
                          x['all_'+child.repYear] = child.countAll;
                          x['new_'+child.repYear] = child.countNew;
                          x['accept_'+child.repYear] = child.countAccept;
                          x['cancel_'+child.repYear] = child.countCancel;
                      })
                    })
                    vm.filteredItems = vm.items
                })
                .catch((error) => console.log(error.message))
                .finally(() => vm.isBusy = false);
        },
        attrRow(value, key, item) {
            if (key.indexOf(this.selectYear)>0)
            if (item['all_'+this.selectYear] == 0)
                return {style: 'background-color: #FF5544'}
        },
        showFilterDialog() {
            this.showFilter = true
        },
        filterItems() {
            this.filter.fieldName = this.filterOption.fieldName;
            this.filter.operation = this.filterOption.operation;
            this.filter.fieldValue = this.filterOption.fieldValue;
            this.showFilter = false;
        },
        onFiltered(filteredItems) {
            this.filteredItems = filteredItems
        },
        filterFunction(row, val) {
            //const { fieldName: fieldName, operation: oper, fieldValue: value, federation: fed } = val;
            var fieldVal = true
            if (val.fieldValue && val.operation>=0 && val.fieldName) {
                var value = parseInt(val.fieldValue, 10)
                var value2 = parseInt(row[val.fieldName+'_'+this.selectYear],10);
                switch (val.operation) {
                    case 0: fieldVal = Boolean(value2 === value);break
                    case 1: fieldVal = Boolean(value2 >= value);break;
                    case 2: fieldVal = Boolean(value2 <= value);break;
                }
            }
            return [
                !val.federation || row.federationName.toUpperCase().indexOf(val.federation.toUpperCase()) >= 0,
                fieldVal,
            ].every(Boolean);
        },
    }
}
